import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import MatrixAssessmentBlock from "./MatrixAssessmentBlock";

var MatrixAssessmentParagraph = /*#__PURE__*/function (_Component) {
  _inherits(MatrixAssessmentParagraph, _Component);

  var _super = _createSuper(MatrixAssessmentParagraph);

  function MatrixAssessmentParagraph(props) {
    var _this;

    _classCallCheck(this, MatrixAssessmentParagraph);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onMatrixAssessmentUpdate", function (block, detail) {
      _this.props.onMatrixAssessmentUpdate(block, detail);
    });

    _this.state = {};
    return _this;
  }

  _createClass(MatrixAssessmentParagraph, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1rem"
        },
        key: "r-paragraph-".concat(this.props.paragraph.paragraphNr)
      }, this.props.paragraph.title != null && this.props.paragraph.title != "" ? /*#__PURE__*/React.createElement("div", {
        className: "single-section matrix-paragraph-title",
        style: {
          paddingTop: "0px",
          marginBottom: "5px"
        }
      }, /*#__PURE__*/React.createElement("strong", null, this.props.paragraph.title)) : null, this.props.paragraph.subtitle != null && this.props.paragraph.subtitle != "" ? /*#__PURE__*/React.createElement("div", {
        className: "single-section matrix-paragraph-subtitle",
        style: {
          paddingTop: "0px",
          marginBottom: "5px"
        }
      }, this.props.paragraph.subtitle) : null, this.props.paragraph.rows.map(function (block) {
        var associatedBlock = _this2.props.associatedParagraph.rows.find(function (b) {
          return b.id == block.id;
        });

        if (associatedBlock != null) {
          var blockIndex = _this2.props.paragraph.rows.indexOf(block) + 1;

          if (!_this2.props.disableNotAchieved && block.cells.find(function (t) {
            return t.id == "F";
          }) == null) {
            block.cells.unshift({
              id: "F",
              text: _this2.props.translate("not-achieved")
            });
          }

          return /*#__PURE__*/React.createElement(MatrixAssessmentBlock, {
            key: block.id,
            sentenceNr: block.sentenceNr,
            assessments: _this2.props.assessments,
            items: _this2.props.items,
            block: block,
            type: "multiple",
            details: _this2.props.details,
            groupAssignment: _this2.props.groupAssignment,
            referenceType: _this2.props.referenceType,
            studentAssessment: _this2.props.studentAssessment,
            onMatrixAssessmentUpdate: _this2.onMatrixAssessmentUpdate,
            index: _this2.props.paragraphIndex != null ? _this2.props.paragraphIndex + "." + blockIndex : null
          });
        }
      }));
    }
  }]);

  return MatrixAssessmentParagraph;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {})(MatrixAssessmentParagraph);